/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Variable d'un template email
 * @export
 * @interface TemplateVariableDto
 */
export interface TemplateVariableDto {
    /**
     * Nom de la variable (format - {{nom}})
     * @type {string}
     * @memberof TemplateVariableDto
     */
    name?: string;
    /**
     * Valeur actuelle de la variable
     * @type {string}
     * @memberof TemplateVariableDto
     */
    value?: string | null;
    /**
     * Placeholder de l'input
     * @type {string}
     * @memberof TemplateVariableDto
     */
    placeholder?: string;
}

/**
 * Check if a given object implements the TemplateVariableDto interface.
 */
export function instanceOfTemplateVariableDto(value: object): value is TemplateVariableDto {
    return true;
}

export function TemplateVariableDtoFromJSON(json: any): TemplateVariableDto {
    return TemplateVariableDtoFromJSONTyped(json, false);
}

export function TemplateVariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateVariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
    };
}

export function TemplateVariableDtoToJSON(json: any): TemplateVariableDto {
    return TemplateVariableDtoToJSONTyped(json, false);
}

export function TemplateVariableDtoToJSONTyped(value?: TemplateVariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
        'placeholder': value['placeholder'],
    };
}

